import { application } from "./application"

import AzNavigatorController from "./az_navigator_controller"
application.register("az-navigator", AzNavigatorController)

import ClassFilterController from "./class_filter_controller"
application.register("class-filter", ClassFilterController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import HerbSelectController from "./herb_select_controller"
application.register("herb-select", HerbSelectController)

import MarkdownPreviewController from "./markdown_preview_controller"
application.register("markdown-preview", MarkdownPreviewController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SubjectKindController from "./subject_kind_controller"
application.register("subject-kind", SubjectKindController)

import TableOfContentsController from "./table_of_contents_controller"
application.register("table-of-contents", TableOfContentsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
